type FieldRow = { label: string; value: string };

/** Definition list of the qualitative card's descriptive label/value rows. */
const FieldList = ({ rows }: { rows: FieldRow[] }) => {
  if (rows.length === 0) return null;
  return (
    <dl className="mt-4 divide-y divide-mui-black-12 dark:divide-mui-white-12">
      {rows.map(r => (
        <div key={r.label} className="flex gap-4 py-2">
          <dt className="w-32 shrink-0 text-sm text-token-text-secondary">{r.label}</dt>
          <dd className="text-sm text-token-text-primary">{r.value}</dd>
        </div>
      ))}
    </dl>
  );
};

export default FieldList;
